import {createRoot, hydrateRoot} from 'react-dom/client';
import InvestorsMedia from '../pages/InvestorsMedia/InvestorsMedia'
import "../index.css";
import "../pages/InvestorsMedia/InvestorsMedia.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<InvestorsMedia {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <InvestorsMedia {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).InvestorsMediaVC = {mount, hydrate, unmount}